import { render, staticRenderFns } from "./ModalBugReport.vue?vue&type=template&id=51ade9dc&scoped=true"
import script from "./ModalBugReport.vue?vue&type=script&lang=js"
export * from "./ModalBugReport.vue?vue&type=script&lang=js"
import style0 from "./ModalBugReport.vue?vue&type=style&index=0&id=51ade9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ade9dc",
  null
  
)

export default component.exports